import { flow, getEnv, types } from "mobx-state-tree";
import Audit from "../../models/Audit";



/**
 * Base Layer of Persistence
 *
 * Shared Values across the session.
 *
 * CRUD operations go through Domain store.
 *
 * Search operations go through domain store.
 *
 *
 */
const AuditStore = types.model('AuditStore',{
  storeUuid: types.identifier,
  auditOptions: types.optional(types.array(Audit), []),
}).actions((self)=>({
  initWithData(auditOptions = []){
    try {
      if (auditOptions) {
        self.auditOptions = auditOptions.map(audit => {
          return Audit.create({
            uuid: audit.id,
            label: audit?.label,
            id: audit?.id
          })
        })
      }
    }catch (e) {
      console.warn("Failed to initWithData", e);
    }
  },
  searchFor(txt){

  },
  reload(){

  },
  save(group){

  },
  update(group){

  },
  add(data){

  },
  delete(group){

  }

}))



export default AuditStore;
